import React from 'react';
import { createStyles, makeStyles } from '@material-ui/styles';
import { Button } from '@material-ui/core';
import { Spinner } from 'react-bootstrap';
import themes from 'styles/themes';

export const useStyles = makeStyles(() =>
    createStyles({
        checkoutButton: {
            textAlign: 'center',
            width: '100%',
            padding: '10px 28px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: 'auto',
            fontSize: 14,
            fontWeight: 400,
            fontFamily: 'PoppinsRegular',
            borderRadius: 29,
            border: 'none',
            textTransform: 'none',
            maxHeight: 44,
        },
    }),
);

interface ButtonCheckoutProps {
    title?: any;
    isWhite?: any;
    handleClick: (ev) => void;
    disabled?: boolean;
    loading?: Boolean;
}

function ButtonCheckout(props: ButtonCheckoutProps) {
    const { title, isWhite, handleClick, disabled } = props;
    const classes = useStyles();
    return (
        <Button
            disabled={disabled}
            style={{
                backgroundColor: `${isWhite ? themes.palette.common.white : themes.palette.primary.main}`,
                color: `${isWhite ? themes.palette.primary.main : themes.palette.common.white}`,
                opacity: disabled ? 0.5 : 1,
            }}
            className={classes.checkoutButton}
            onClick={handleClick}
        >
            {props.loading ? (
                <>
                    Adding to bag <Spinner animation="border" style={{ marginLeft: 10, width: 18, height: 18 }} />
                </>
            ) : (
                title
            )}
        </Button>
    );
}

export default ButtonCheckout;
